
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Plus } from "lucide-react"

import { Button } from "@/components/ui/button"
import { AppointmentCalendar } from "@/components/appointments/appointment-calendar"
import { AddAppointmentDialog } from "@/components/appointments/add-appointment-dialog"
import { PageHeader } from "@/components/shared/page-header"

export default function AppointmentsPage() {
  const { t } = useTranslation()
  const [isAddAppointmentOpen, setIsAddAppointmentOpen] = useState(false)

  return (
    <div className="space-y-6">
      <PageHeader title={t("appointments.title")}>
        <Button onClick={() => setIsAddAppointmentOpen(true)} className="w-full sm:w-auto">
          <Plus className="mr-2 h-4 w-4" />
          {t("appointments.addAppointment")}
        </Button>
      </PageHeader>
      <AppointmentCalendar />
      <AddAppointmentDialog open={isAddAppointmentOpen} onOpenChange={setIsAddAppointmentOpen} />
    </div>
  )
}
